import { Directive, HostListener, Input, Optional, SkipSelf, TemplateRef } from '@angular/core';

import { DropdownComponent } from './../dropdown.component';

@Directive({ selector: '[targetFor]' })
export class NestedTemplateTriggerDirective {
  @Input('targetFor') public templateRef: TemplateRef<any>;

  constructor(@Optional() @SkipSelf() private dropdownComponent: DropdownComponent) {}

  // eslint-disable-next-line ban/ban
  @HostListener('click', ['$event'])
  public setTemplate($event: Event): void {
    $event.preventDefault();
    if (!this.templateRef || !this.dropdownComponent) return;
    this.dropdownComponent.setNestedTemplate(this.templateRef);
  }
}
